'use client';
import DrawerModal from '@/components/drawer-modal/DrawerModal';
import BurgerMenu from '@/components/ui/icons/burger-menu';
import { useState } from 'react';
import MenuContent from './MenuContent';
import { useLocale } from 'next-intl';
import AuthModal from '@/components/ui/modals/auth-modal';

const ResponsiveSideMenu = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [auth, setAuth] = useState(false);
  const locale = useLocale();
  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  return (
    <>
      <BurgerMenu
        className='size-5 lg:hidden'
        onClick={() => setOpenDrawer(true)}
      />

      <DrawerModal
        isOpen={openDrawer}
        onClose={handleCloseDrawer}
        position={locale === 'ar' ? 'right' : 'left'}
      >
        <MenuContent onClose={handleCloseDrawer} setAuth={setAuth} />
      </DrawerModal>
      <AuthModal auth={auth} setAuth={setAuth} />
    </>
  );
};

export default ResponsiveSideMenu;
